import { inject, Injectable } from '@angular/core';
import { ReportMapper } from '../../sales/mappers/report.mapper';
import { Report } from '@modules/report/models/report.model';
import { HsBlazorService } from '@hsetu/core-services';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private readonly _serviceKey = 'kfmReport';
  private readonly _blazorService = inject(HsBlazorService);
  private readonly _mapper = new ReportMapper();

  public async update(value: Report): Promise<boolean> {
    const request = this._mapper.mapReportRequest(value);
    const result = await this._blazorService.invokeService(
      this._serviceKey,
      'Put',
      request,
    );

    return !!result;
  }
}
